import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, Observable, throwError } from 'rxjs';
import type { SponserContract } from '@fitness-force/models';
import { environment } from '@fitness-force/environments';
import { AppErrors, NotFoundError } from '@fitness-force/models';;
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';

@Injectable({
  providedIn: 'root'
})
export class SponserContractsService {
  private http = inject(HttpClient);


  getTenantsSponsorContracts(tenantId: number): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.SPONSER.GET_TENANT_SPONSOR_CONTRACTS
      .replace('{tenant_id}', tenantId.toString());
    return this.http.get<any>(url).pipe(
      map((res: any) => {
        return res; 
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getCompanySponsorContracts(): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.SPONSER.GET_COMPANY_SPONSOR_CONTRACTS;
    return this.http.get<any>(url).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }
} 